export default __webpack_public_path__ + "33db28a31ae0d0dca0e353543c8ed88d.png";